import React, { Component } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel"; 
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import liffHelper from "../../utils/liffHelper";
import { Redirect } from "react-router-dom";
import Noredi from "./ProfileNoredi";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
// import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
// import { makeStyles } from '@material-ui/core/styles';
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing(3, 2),
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

var liff = window.liff;
// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: "Admin",
      password: "",
      weight: "",
      weightRange: "",
      showPassword: false,
      profile: false,
      groupold: "",
    };
  }
  async componentDidMount() {
    const profile = await liff.getContext();
    console.log(profile);
    alert(profile);
    const profile2 = await liff.getProfile();
    // alert(profile2.userId)
    this.setState({
      profile: {
        type: profile.type,
        viewType: profile.viewType,
        userId: profile.userId,
        utouId: profile.utouId,
        roomId: profile.roomId,
        groupId: profile.groupId,
        displayName: profile2.displayName,
        pictureUrl: profile2.pictureUrl,
      },
      // redi:{redirect: true}
    });
    const chkad = await liffHelper.chkad(this.state.profile.userId);
    if (chkad != undefined) {
      // alert(chkad.line_id)
      this.setState({
        groupold: chkad.line_id,
        openZ: true,
      });
    } else {
      // alert(chkad)
      this.setState({
        groupold: chkad,
        openZ: true,
      });
    }
  }
  renderRedirect = () => {
    if (
      this.state.password == "Rafco" ||
      this.state.password == "Rplc" ||
      this.state.password == "Motor" ||
      this.state.password == "Aicp"
    ) {
      return (
        <Redirect
          to={{
            pathname: "/ProfileNative",
            state: {
              type: this.state.profile.type,
              viewType: this.state.profile.viewType,
              userId: this.state.profile.userId,
              utouId: this.state.profile.utouId,
              roomId: this.state.profile.roomId,
              groupId: this.state.profile.groupId,
              displayName: this.state.profile.displayName,
              pictureUrl: this.state.profile.pictureUrl,
              password: this.state.password,
            },
          }}
        />
      );
    } else if (this.state.password.substring(0, 6).toLowerCase() == "cus123") {
      alert(this.state.profile.userId)
      // alert(this.state.groupold)
      // if (this.state.groupold == undefined) {
      //   return (
      //     <Redirect
      //       to={{
      //         pathname: "/lineregis",
      //         state: { 
      //           type: this.state.profile.type,
      //           viewType: this.state.profile.viewType,
      //           userId: this.state.profile.userId,
      //           utouId: this.state.profile.utouId,
      //           roomId: this.state.profile.roomId,
      //           groupId: this.state.profile.groupId,
      //           displayName: this.state.profile.displayName,
      //           pictureUrl: this.state.profile.pictureUrl,
      //           password: this.state.password,
      //         },
      //       }}
      //     />
      //   );
      // } 
      // else if (
      //   this.state.groupold != undefined &&
      //   this.state.groupold != " "
      // ) {
      //   return (
      //     <Redirect
      //       to={{
      //         pathname: "/lineadmin",
      //         state: {
      //           type: this.state.profile.type,
      //           viewType: this.state.profile.viewType,
      //           userId: this.state.profile.userId,
      //           utouId: this.state.profile.utouId,
      //           roomId: this.state.profile.roomId,
      //           groupId: this.state.profile.groupId,
      //           displayName: this.state.profile.displayName,
      //           pictureUrl: this.state.profile.pictureUrl,
      //           password: this.state.password,
      //         },
      //       }}
      //     />
      //   );
      // }
    } else if (
      this.state.password.substring(0, 9).toLowerCase() == "aamcus123"
    ) {
      // alert(this.state.password)
      // alert(this.state.groupold)
      if (this.state.groupold == undefined) {
        return (
          <Redirect
            to={{
              pathname: "/CraamG",
              state: {
                type: this.state.profile.type,
                viewType: this.state.profile.viewType,
                userId: this.state.profile.userId,
                utouId: this.state.profile.utouId,
                roomId: this.state.profile.roomId,
                groupId: this.state.profile.groupId,
                displayName: this.state.profile.displayName,
                pictureUrl: this.state.profile.pictureUrl,
                password: this.state.password,
              },
            }}
          />
        );
      } else if (
        this.state.groupold != undefined &&
        this.state.groupold != " "
      ) {
        return (
          <Redirect
            to={{
              pathname: "/CraamG",
              state: {
                type: this.state.profile.type,
                viewType: this.state.profile.viewType,
                userId: this.state.profile.userId,
                utouId: this.state.profile.utouId,
                roomId: this.state.profile.roomId,
                groupId: this.state.profile.groupId,
                displayName: this.state.profile.displayName,
                pictureUrl: this.state.profile.pictureUrl,
                password: this.state.password,
              },
            }}
          />
        );
      }
    } else if (this.state.password == "pgh123") {
      return (
        <Redirect
          to={{
            pathname: "/lineregispgh",
            state: {
              type: this.state.profile.type,
              viewType: this.state.profile.viewType,
              userId: this.state.profile.userId,
              utouId: this.state.profile.utouId,
              roomId: this.state.profile.roomId,
              groupId: this.state.profile.groupId,
              displayName: this.state.profile.displayName,
              pictureUrl: this.state.profile.pictureUrl,
              password: this.state.password,
            },
          }}
        />
      );
    } else if (this.state.password.toLowerCase() == "famin") {
      return (
        <Redirect
          to={{
            pathname: "/Famin",
            state: {
              type: this.state.profile.type,
              viewType: this.state.profile.viewType,
              userId: this.state.profile.userId,
              utouId: this.state.profile.utouId,
              roomId: this.state.profile.roomId,
              groupId: this.state.profile.groupId,
              displayName: this.state.profile.displayName,
              pictureUrl: this.state.profile.pictureUrl,
              password: this.state.password,
            },
          }}
        />
      );
    } else if (this.state.password.toLowerCase() == "famout") {
      return (
        <Redirect
          to={{
            pathname: "/Famout",
            state: {
              type: this.state.profile.type,
              viewType: this.state.profile.viewType,
              userId: this.state.profile.userId,
              utouId: this.state.profile.utouId,
              roomId: this.state.profile.roomId,
              groupId: this.state.profile.groupId,
              displayName: this.state.profile.displayName,
              pictureUrl: this.state.profile.pictureUrl,
              password: this.state.password,
            },
          }}
        />
      );
    }
    // if (this.state.password == "Admin") {
    //   return <Redirect
    //     to={{
    //       pathname: '/regisadmin',
    //       state: {password : this.state.password }
    //     }}
    //   />
    // }
  };

  handleChange(event) {
    this.setState({ password: event.target.value });
  }
  //    handleChange = prop => event => {
  //     setValues({ ...values, [prop]: event.target.value });
  //   };

  //    handleClickShowPassword = () => {
  //     setValues({ ...values, showPassword: !values.showPassword });
  //   };

  //    handleMouseDownPassword = event => {
  //     event.preventDefault();
  //   };

  render() {
    const classes = this.props;

    return (
      // <div className={classes.root}>
      // <div>
      //   <Noredi />

      <div className={classes.root}>
        {/* <Noredi /> */}
        {/* {this.renderRedirect()} */}
        <Paper className={classes.paper} style={{ marginTop: 10, padding: 30 }}>
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.profile.displayName}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              {/* {this.state.amount} */}
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={this.handleChange.bind(this)}
              />
            </form>
          </div>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/components/RoutIndex.js